import React, { useEffect, useMemo, useState } from 'react';
import { FaListUl, FaGripHorizontal } from 'react-icons/fa';
import { Modal } from "react-bootstrap";
import { getCategories, GetAllProducts, GetWishListItems, AddItemToWishList, RemoveItemFromWishList } from '../Data';
import { Global } from '../Variables/Global';
import ProductGrid from '../Common/ProductGrid';
import ProductList from '../Common/ProductList';
import Util from '../../Classes/Utils';
import { useNavigate } from 'react-router-dom';
import Category from '../Category/Category';
import Pagination from '../Pagination/Pagination'
import ProductModal from '../Common/ProductModal';
import { toast } from 'react-toastify';
import Slider2 from '../../Images/shopBanner/SLIDER 2.jpg';
import CategorySlider from '../Home/CategorySlider/CategorySlider';
import Cookies from 'js-cookie';


const Shop = () => {
	const [showList, setShowList] = useState("grid");
	const [showModal, setShowModal] = useState(false);
	const [productDetails, setProductDetails] = useState();
	const [currentPage, setCurrentPage] = useState(1);
	const [isLogged, setIsLogged] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [WishListItems, setWishListItems] = useState([]);

	const [shopItems, setShopItems] = useState([]);
	const [shopItemsCount, setShopItemsCount] = useState(0);
	// const [test, setTest] = useState({
	// 	products: [],
	// 	productCount: 0
	// })

	const navigate = useNavigate();
	let LIMIT = 9;
	let a = 0;
	const token = Cookies.get("CustomerToken");

	const GetAllProductsForShop = useMemo(() => {
		const offset = new Date().getTimezoneOffset();
		GetAllProducts(currentPage, LIMIT).then((Result) => {
			setShopItems(Result.finalList);
			setShopItemsCount(Result.count);
		})

	}, [currentPage])


	const GetWishListItemsForShop = () => {
		var groupId;
		if (Cookies.get("WishList") !== undefined) {
			groupId = 4
		} else {
			groupId = 3
		}
		const getItem = (Cookies.get('WishList') !== undefined);
		if (getItem) {
			var WishlistId = Cookies.get("WishList");
			GetWishListItems(WishlistId, groupId, token).then((Result) => {
				setWishListItems(Result.WishlistItems);
			});
		}
	}
	const HandleAddToWishList = (ProductId, ProductVariationId) => {
		if (!isLogged) {
			navigate('/Authentication');
			return;
		}

		const WishlistId = Cookies.get("WishList");
		if (!WishlistId) return;

		AddItemToWishList(WishlistId, ProductId, ProductVariationId, token)
			.then((response) => {
				if (!response.ok) throw new Error();

				toast.success("Item added to wishlist");

				// ✅ UPDATE STATE (IMPORTANT)
				setWishListItems(prev => [
					...prev,
					{
						ProductId,
						DefaultProductVariationId: ProductVariationId
					}
				]);
			})
			.catch(() => {
				toast.error("Could Not Add");
			});
	};


	const HandleRemoveFromWishList = (ProductId) => {
		if (!isLogged) {
			navigate('/Authentication');
			return;
		}

		const WishlistId = Cookies.get("WishList");
		if (!WishlistId) return;

		RemoveItemFromWishList(ProductId, WishlistId, token)
			.then((response) => {
				if (!response.ok) throw new Error();

				toast.success("Item removed from wishlist");

				// ✅ UPDATE STATE (IMPORTANT)
				setWishListItems(prev =>
					prev.filter(item => item.ProductId !== ProductId)
				);
			})
			.catch(() => {
				toast.error("Could Not Remove");
			});
	};

	const handleCategoryChange = () => {
		setCurrentPage(1);        // ✅ reset pagination
		window.scrollTo({ top: 0, behavior: 'smooth' }); // ✅ scroll top
	};

	useEffect(() => {
		setIsLoading(true);
		if (Cookies.get("CustomerToken") === undefined) {
			setIsLogged(false);
		} else {
			setIsLogged(true);
		}

		GetWishListItemsForShop();
		setTimeout(() => {
			setIsLoading(false);
		}, 2000);
	}, [])

	return (
		<>
			<div className="breadcrumb-area mb-5">
				<div className="container">
					<div className="row">
						<div className="col">
							<div className="breadcrumb-container HomeShop">
								<ul>
									<li><a href="index.html"><i className="fa fa-home"></i> Home</a></li>
									<li className="active">Shop</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>


			{
				isLoading ? (
					<div className="spinner-container">
						<div className="loading-spinner"></div>
					</div>
				) : (
					<>
						<div className="shop-page-container mb-5">
							<div className="container">
								<div className="row">
									<div className="col-lg-4 order-2 order-lg-1">

										<div className="sidebar-area">

											<div className="sidebar mb-3">
												<Category onCategoryClick={handleCategoryChange} />
												<ul className="product-categories">
												</ul>
											</div>
											<div className="">
											</div>
										</div>

									</div>
									<div className="col-lg-8 order-1 order-lg-2 mb-sm-35 mb-xs-3">



										<div className="shop-page-banner mb-3">
											<a href="">
												<img width="870" height="331" src={Slider2} className="img-fluid"
													alt="" />
											</a>
										</div>



										<div className="shop-header mb-3 mt-2">
											<div className="row">
												<div className="col-lg-4 col-md-4 col-sm-12 d-flex align-items-center">

													<div className="view-mode-icons mb-xs-10 directionLtr">
														<a className={showList.includes("grid") ? "active" : ""} data-target="grid" onClick={() => setShowList('grid')}><FaGripHorizontal /></a>
														<a className={showList.includes("list") ? "active" : ""} data-target="list" onClick={() => setShowList('list')}><FaListUl /></a>
													</div>
												</div>
												<div
													className="col-lg-8 col-md-8 col-sm-12 d-flex flex-column flex-sm-row justify-content-between align-items-left align-items-sm-center">

													<div className="sort-by-dropdown d-flex align-items-center mb-xs-10">

													</div>
												</div>
											</div>
										</div>

										{/* className="shop-product-wrap list row no-gutters mb-35" */}
										<div className={"shop-product-wrap row no-gutters mb-3 " + showList} >
											{
												shopItems.map((product, index) => {
													return (
														<div key={index} className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
															<ProductGrid
																product={product}
																WishListItems={WishListItems}
																HandleAddToWishList={HandleAddToWishList}
																HandleRemoveFromWishList={HandleRemoveFromWishList}
																setShowModal={setShowModal}
																productDetails={productDetails}
																setProductDetails={setProductDetails}
															/>
															<ProductList
																product={product}
																WishListItems={WishListItems}
																HandleAddToWishList={HandleAddToWishList}
																HandleRemoveFromWishList={HandleRemoveFromWishList}
																setShowModal={setShowModal}
																productDetails={productDetails}
																setProductDetails={setProductDetails}
															/>
															{
																showModal && (
																	<ProductModal
																		productDetails={productDetails}
																		WishListItems={WishListItems}
																		HandleAddToWishList={HandleAddToWishList}
																		HandleRemoveFromWishList={HandleRemoveFromWishList}
																		showModal={showModal}
																		setShowModal={setShowModal}
																	/>
																)
															}
														</div>




													)
												})





											}
										</div>

										{/* <div className="pagination-container">
								<div className="container">
									<div className="row">
										<div className="col-lg-12">

											<div className="pagination-content text-center">
												<ul>
													<li><a className="active" href="#">1</a></li>
													<li><a href="#">2</a></li>
													<li><a href="#">3</a></li>
													<li><a href="#">4</a></li>
													<li><a href="#"><i className="fa fa-angle-right"></i></a></li>
												</ul>
											</div>

										</div>
									</div>
								</div>
							</div> */}
										<Pagination
											currentPage={currentPage}
											totalCount={shopItemsCount}
											pageSize={LIMIT}
											onPageChange={page => setCurrentPage(page)}
										/>
										{/* {totalPage.length > 1 && (
								<div className="row mt-4">
									<div className="col-12">
										<div className="pagination">
											{totalPage.map((p) => {
												return (
													<div key={p.index} className={
														p.index === page
															? "pagination-pages active-page"
															: "pagination-pages"
													} onClick={() => pageChange(p.index)}>
														<a>{p.pageNumber}</a>
													</div>
												)
											})}
										</div>
									</div>
								</div>
							)} */}


									</div>
								</div>
								<CategorySlider />
							</div>
						</div>

						{/* <div class="modal fade quick-view-modal-container" id="quick-view-modal-container" tabindex="-1" role="dialog"
		aria-hidden="true">
		<div class="modal-dialog modal-dialog-centered" role="document">
			<div class="modal-content">
				<div class="modal-header">
					<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
				</div>
				<div class="modal-body">
					<div class="row">
						<div class="col-lg-5 col-md-6 col-xs-12">
							<div class="product-image-slider">
								<div class="tab-content product-large-image-list" id="myTabContent">
									<div class="tab-pane fade show active" id="single-slide1" role="tabpanel"
										aria-labelledby="single-slide-tab-1">
										<div class="single-product-img img-full">
											<img width="350" height="350" src="assets/images/PRODUCTS PICTURES FOR WEB/JAMS/APPLE JAM (800G)/APPLE JAM (800G) 1.jpg"
												class="img-fluid" alt="" />
										</div>
									</div>
									<div class="tab-pane fade" id="single-slide2" role="tabpanel"
										aria-labelledby="single-slide-tab-2">
										<div class="single-product-img img-full">
											<img width="350" height="350" src="assets/images/PRODUCTS PICTURES FOR WEB/JAMS/CACTUS JAM (800G)/CACTUS JAM (800G) 1.jpg"
												class="img-fluid" alt="" />
										</div>
									</div>
									<div class="tab-pane fade" id="single-slide3" role="tabpanel"
										aria-labelledby="single-slide-tab-3">
										<div class="single-product-img img-full">
											<img width="350" height="350" src="assets/images/PRODUCTS PICTURES FOR WEB/JAMS/APRICOT JAM (450G)/APRICOT JAM (450 G) 1.jpg"
												class="img-fluid" alt="" />
										</div>
									</div>
									<div class="tab-pane fade" id="single-slide4" role="tabpanel"
										aria-labelledby="single-slide-tab-4">
										<div class="single-product-img img-full">
											<img width="350" height="350" src="assets/images/PRODUCTS PICTURES FOR WEB/JAMS/RASPBERRY JAM (450 G)/RASPBERRY JAM (450 G) 2.jpg"
												class="img-fluid" alt="" />
										</div>
									</div>
								</div>
								<div class="product-small-image-list">
									<div class="nav small-image-slider" role="tablist">
										<div class="single-small-image img-full">
											<a data-bs-toggle="tab" id="single-slide-tab-1" href="#single-slide1"><img
													width="350" height="350" src="assets/images/PRODUCTS PICTURES FOR WEB/JAMS/APPLE JAM (800G)/APPLE JAM (800G) 1.jpg"
													class="img-fluid" alt="" /></a>
										</div>
										<div class="single-small-image img-full">
											<a data-bs-toggle="tab" id="single-slide-tab-2" href="#single-slide2"><img
													width="350" height="350" src="assets/images/PRODUCTS PICTURES FOR WEB/JAMS/CACTUS JAM (800G)/CACTUS JAM (800G) 1.jpg"
													class="img-fluid" alt="" /></a>
										</div>
										<div class="single-small-image img-full">
											<a data-bs-toggle="tab" id="single-slide-tab-3" href="#single-slide3"><img
													width="350" height="350" src="assets/images/PRODUCTS PICTURES FOR WEB/JAMS/APRICOT JAM (450G)/APRICOT JAM (450 G) 1.jpg"
													class="img-fluid" alt="" /></a>
										</div>
										<div class="single-small-image img-full">
											<a data-bs-toggle="tab" id="single-slide-tab-4" href="#single-slide4"><img
													width="350" height="350" src="assets/images/PRODUCTS PICTURES FOR WEB/JAMS/RASPBERRY JAM (450 G)/RASPBERRY JAM (450 G) 2.jpg"
													class="img-fluid" alt="" /></a>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="col-lg-7 col-md-6 col-xs-12">
							<div class="product-feature-details">
								<h2 class="product-title mb-15">JAMS</h2>

								<h2 class="product-price mb-15">
									<span class="main-price">$12.90</span>
									<span class="discounted-price"> $10.00</span>
								</h2>

								<p class="product-description mb-20">Description</p>


								<div class="cart-buttons mb-20">
									<div class="pro-qty mr-10">
										<input type="text" value="1" />
									</div>
									<div class="add-to-cart-btn">
										<a href="#"><i class="fa fa-shopping-cart"></i> Add to Cart</a>
									</div>
								</div>


								<div class="social-share-buttons">
									<h3>share this product</h3>
									<ul>
										<li><a class="facebook" href="#"><i class="fa fa-facebook"></i></a></li>
										<li><a class="instagramm" href="#"><i class="fa fa-instagram"></i></a></li>

									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

		</div>
	</div> */}
					</>
				)
			}
		</>
	)
}

export default Shop